module.exports = __webpack_public_path__ + "static/media/img_process2.d1edbc13.png";